import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Base64 } from 'js-base64';
import { environment } from '@/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class InformacionService {

  private endpoint: string | null;

  constructor
  (
    private httpClient: HttpClient
  ) 
  { 
    this.endpoint = Base64.decode(environment.apiEndpoint) + '/catalogos/Informacion';
  }

  getInfoCombustible(idCarga: string){
    return this.httpClient.get(this.endpoint + '/Combustible/' + idCarga);
  }
}
